export const defaultState: Fields = {
  isLoading: false,
  isCompanyRequestedForDeletion: false,
  isRemovingDeletionRequest: false,
};

export interface Fields {
  isLoading: boolean;
  isCompanyRequestedForDeletion: boolean;
  isRemovingDeletionRequest: boolean;
}
